const doc = [({"en":({"js":({"live_streaming_feeds":({"viewer":({"speaker_isnt_broadcasting":"Speaker isn't broadcasting."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;